module.exports = __webpack_public_path__ + "static/media/ServicesSensoryIcon.eabc04a3.svg";